export interface IPrintPreviewMappingValue {
    closingValue: number;
    openingValue: number;
}
